import makeStyles from '@material-ui/core/styles/makeStyles';

const useTextFieldErrorClasses = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.themeCommon.red.light,
  },
}));

export default useTextFieldErrorClasses;
